var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-container",staticStyle:{"width":"100%"}},[_c('v-row',{attrs:{"dense":"","no-gutters":""}},[_c('v-col',{attrs:{"cols":"12"}},[_c('Table',{key:_vm.tableKey,attrs:{"items":_vm.logs,"loading":_vm.loading},on:{"fetchInternalJobs":function($event){return _vm.fetchInternalJobs($event)}}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }